import { MoovyDialog, MoovyRestricted } from '../../components'

import { UseMutationResult } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { FormattedMessage } from 'react-intl'
import { WhitelistedVehicleDTO } from '../../apis/whitelist/dto'
import { hasPermission, MoovyAction } from '../../app/permissions'
import useAuth from '../../hooks/useAuth'
import FormWhitelistedVehicle, {
  OnSubmitCallback,
} from './formWhitelistedVehicle'

export type ModalWhitelistedVehicleProps = {
  open: boolean
  vehicle: WhitelistedVehicleDTO | null
  mutations: Partial<{
    [key in MoovyAction]: UseMutationResult<
      AxiosResponse<any, any>,
      unknown,
      any,
      unknown
    >
  }>
  errorTitleKeys: Partial<{ [key in MoovyAction]: string }>
  modalTitleKeys: Partial<{ [key in MoovyAction]: string }>
  formTitleKeys: Partial<{ [key in MoovyAction]: string }>
  submitButtonContentKeys: Partial<{ [key in MoovyAction]: string }>
  onSubmit: OnSubmitCallback
  onDelete: OnSubmitCallback
  onCancel: () => void
}

const FORM_REFERENCE = 'formWhitelistedVehicle'

const ModalWhitelistedVehicle = (props: ModalWhitelistedVehicleProps) => {
  const { isAdmin } = useAuth()

  // Edit the vehicle if it exists, otherwise create a new one
  const isCreateModal = !props.vehicle

  // Authorization
  if (isCreateModal && !hasPermission(isAdmin, 'CREATE', 'WHITELIST')) {
    return null
  }
  const hasEditPermission = hasPermission(isAdmin, 'EDIT', 'WHITELIST')

  // Determine mode based on type and permissions
  const mode: MoovyAction = isCreateModal
    ? 'CREATE'
    : hasEditPermission
    ? 'EDIT'
    : 'READ'

  return (
    <>
      <MoovyDialog
        open={props.open}
        onCancel={props.onCancel}
        deleteButtonContent={
          mode === 'EDIT' ? (
            <MoovyRestricted action="DELETE" resource="WHITELIST">
              <FormattedMessage id="common.buttons.remove" />
            </MoovyRestricted>
          ) : undefined
        }
        formReference={FORM_REFERENCE}
        errorTitleKey={props.errorTitleKeys[mode]}
        mutation={props.mutations[mode]}
        modalTitle={<FormattedMessage id={props.modalTitleKeys[mode]} />}
        submitButtonContent={
          <FormattedMessage id={props.submitButtonContentKeys[mode]} />
        }
        hideCancelButton={mode === 'READ'}
      >
        <FormWhitelistedVehicle
          onSubmit={props.onSubmit}
          onDelete={props.onDelete}
          vehicle={props.vehicle}
          formReference={FORM_REFERENCE}
          formTitleKey={props.formTitleKeys[mode] ?? ''}
          mode={mode}
        />
      </MoovyDialog>
    </>
  )
}

export default ModalWhitelistedVehicle
